import { render, staticRenderFns } from "./DraggableFieldsList.vue?vue&type=template&id=05eb80b2&scoped=true"
import script from "./DraggableFieldsList.vue?vue&type=script&lang=js"
export * from "./DraggableFieldsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb80b2",
  null
  
)

export default component.exports